import { useState } from "react";
import { useSubmitGeneralFeedbackMutation } from "../../slices/fun_stuff/quizAdminSlice";
import { Form, Button } from "react-bootstrap";
import ImageUpload from "../ImageUpload";
import Loader from "../Loader";

const GeneralFeedback = (() => {
    const [screenshotId, setScreenshotId] = useState('');
    const [player, setPlayer] = useState('');
    const [playerEmail, setPlayerEmail] = useState('');
    const [feedback, setFeedback] = useState('');


    const [submitFeedback, { isLoading }] = useSubmitGeneralFeedbackMutation();

    async function submitHandler(e) {
        e.preventDefault();
        if (!feedback) {
            window.alert("Please enter feedback.");
            return;
        }
        
        try {
            await submitFeedback({
                player,
                player_email: playerEmail,
                screenshot_id: screenshotId,
                feedback,
            }).unwrap();
            window.alert("Feedback submitted successfully!");
            // hideFeedbackForm();
        } catch (error) {
            console.log(error?.data?.message || error.error);
            window.alert('Submission failed');
        }
    }

    return (
        <Form onSubmit={(e) => submitHandler(e)}>
            <h2>Submit Feedback</h2>

            <Form.Group controlId='name' className='my-1' style={{ maxWidth: '250px' }}>
                <Form.Label>Name</Form.Label>
                <Form.Control 
                type='text'
                placeholder='Enter Name'
                onChange={(e) => setPlayer(e.target.value)}>
                </Form.Control>
            </Form.Group>
    
            <Form.Group controlId='email' className='my-1' style={{ maxWidth: '250px' }}>
                <Form.Label>Email - if you'd like a response</Form.Label>
                <Form.Control 
                type='email'
                placeholder='Email (optional)'
                onChange={(e) => setPlayerEmail(e.target.value)}>
                </Form.Control>
            </Form.Group>

            <Form.Group controlId={`feedback`} className="my-2">
                <Form.Label>Feedback</Form.Label>
                <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter feedback"
                    onChange={(e) => setFeedback(e.target.value)}
                />
            </Form.Group>

            <Form.Label>Upload Screenshot</Form.Label>
            <ImageUpload setCloudflareId={setScreenshotId} />
    
            <Button type='submit' className='quiz-btn-dark mt-2' disabled={ isLoading }>
                Submit Feedback
            </Button>
    
            { isLoading && <Loader /> }
            
        </Form>
    );
})

export default GeneralFeedback;